import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { BaseStatusViewComponent } from '../base-status-view.component';
import { Kontrolltermin } from '../../../services/kontrolltermin.service';

@Component({
  selector: 'app-abgebrochen-view',
  templateUrl: './abgebrochen-view.component.html',
  styleUrls: ['./abgebrochen-view.component.scss']
})
export class AbgebrochenViewComponent extends BaseStatusViewComponent implements OnInit {
  
  constructor(
    private router: Router,
    formBuilder: FormBuilder
  ) {
    super(formBuilder);
  }
  
  getStatusTitle(): string {
    return 'Abgebrochener Kontrolltermin';
  }
  
  getAvailableActions(): string[] {
    return []; // No actions possible - read-only info
  }
  
  getFormFields(): any[] {
    return []; // No form fields - read-only
  }
  
  onSave(): void {
    // No save action for abgebrochen
    console.log('❌ ABGEBROCHEN: No save action available');
  }
  
  onCancel(): void {
    this.logAction('Cancel');
    console.log('❌ ABGEBROCHEN: Cancel action triggered');
    this.router.navigate(['/kontrolltermine']);
  }
  
  onStatusChange(newStatus: string): void {
    // No status change possible for abgebrochen
    console.log('❌ ABGEBROCHEN: No status change possible');
  }
}
